import { render, staticRenderFns } from "./AccessLevelDynamicBadge.vue?vue&type=template&id=259b8942&"
import script from "./AccessLevelDynamicBadge.vue?vue&type=script&lang=ts&"
export * from "./AccessLevelDynamicBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports